import type { ReactNode } from "react";

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <h1 className="text-[1.6rem] leading-tight font-semibold">{title}</h1>
      {actions}
    </div>
  );
}
